import { UserRepository } from '@/features/user/api/userRepository';
import { useLoginState } from '@/composables/store/useLoginStore';

/** ユーザーIdの更新 */
export const useUpdateUser = () => {
  const repository = UserRepository();
  const { userId, setUserId } = useLoginState();

  const update = async () => {
    const { data, error } = await repository.get(userId.value);
    if (data.value) await setUserId(data.value.user?.id);
    return { data, error };
  };

  return { update };
};
